/**
 * Scrolls the sidebar containing the element as little as needed to show the element
 * completely below the sticky header, which scrollIntoView would not take into account.
 */
export function scrollIntoViewInSidebar(
  element: HTMLElement,
  behavior: ScrollBehavior,
) {
  const sidebar = element.closest<HTMLElement>(".sidebar");
  if (!sidebar) return;
  const header = sidebar.querySelector<HTMLElement>(".sidebar-header");
  const sidebarRect = sidebar.getBoundingClientRect();
  const visibleTop = sidebarRect.top + (header?.offsetHeight ?? 0);
  const visibleBottom = sidebarRect.bottom;
  const elementRect = element.getBoundingClientRect();

  if (elementRect.top < visibleTop)
    sidebar.scrollBy({ top: elementRect.top - visibleTop, behavior });
  else if (elementRect.bottom > visibleBottom)
    sidebar.scrollBy({
      //an element higher than the visible area shows its top
      top: Math.min(
        elementRect.bottom - visibleBottom,
        elementRect.top - visibleTop,
      ),
      behavior,
    });
}
